import React, { useState } from "react";

import Header from "./Header";

import axios from "axios";

import Swal from "sweetalert2";

import config from "../../config";
import Footer from "./Footer";

const Developer_apis = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }

  const [state, setState] = React.useState({
    shipment_list: "",
    customer_id: "",
    isLoading: true,
  });
  const [products, setProducts] = React.useState([]);
  const [b2bproducts, setb2bProducts] = React.useState([]);

  const [companyDetail, setCompanyDetail] = React.useState([]);
  const [revealed, setRevealed] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [toastDanger, setToastDanger] = useState(false);
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 5000,
  });

  React.useEffect(() => {
    shipment_list();
    product_list();
    company_detail();
    b2b_product_list();
  }, []);

  const shipment_list = (status) => {
    let dataToSend = { customer_id: userData.customer_id };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/user_secret_key";

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        setState({
          shipment_list: res.data.output,
          customer_id: res.data.customer_id,
          isLoading: false,
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const product_list = () => {
    let dataToSend = {
      mode: "Domestic",
      order_type: "Forward",
    };

    let url = config.apiUrl + "/shipment/all_product_list";

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        setProducts(res.data.output || []);
      })
      .catch(() => {});
  };

  const b2b_product_list = () => {
    let dataToSend = {
      mode: "Domestic",
      order_type: "Forward",
    };

    let url = config.apiUrl + "/shipment/all_b2b_product_list";

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        setb2bProducts(res.data.output || []);
      })
      .catch(() => {});
  };
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // console.log('Text copied to clipboard');
        Toast.fire({
          background: "rgb(8, 88, 185)",
          type: "success",
          title: "Text copied to clipboard",
          color: "white",
        });

        // You can also show a success message or perform any other desired action here
      })
      .catch((error) => {
        // console.error('Error copying text to clipboard:', error);
        // You can show an error message or handle the error in any appropriate way here
      });
  };
  const handleCopy1 = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // console.log('Text copied to clipboard');
        Toast.fire({
          background: "rgb(8, 88, 185)",
          type: "success",
          title: "Text copied to clipboard",
          color: "white",
        });

        // You can also show a success message or perform any other desired action here
      })
      .catch((error) => {
        // console.error('Error copying text to clipboard:', error);
        // You can show an error message or handle the error in any appropriate way here
      });
  };

  const company_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setCompanyDetail(res.data.companyDetail || []);
      })
      .catch((e) => {});
  };

  const showToast = (msg, danger = false) => {
    setToastMessage(msg);
    setToastDanger(danger);

    setTimeout(() => {
      setToastMessage("");
    }, 2200);
  };

  const maskKey = (key) => {
    if (!key) return "";

    return key.slice(0, 7) + "••••••••••••" + key.slice(-4);
  };

  const copyText = async (text) => {
    if (!text) {
      showToast("Nothing to copy.", true);
      return;
    }

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";

        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      showToast("Copied to clipboard.");
    } catch (error) {
      showToast("Could not copy.", true);
    }
  };

  const toggleReveal = (id) => {
    setRevealed((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const refreshSecretKey = () => {
    if (
      !window.confirm(
        "Refresh API key? Your current key will stop working immediately. Any integration using it must be updated with the new key."
      )
    ) {
      return;
    }

    // IMPORTANT:
    // This only changes the frontend state if shipment_list is a React state value.
    // We should call your backend API here to actually generate/save a new key.
    showToast("API key refreshed.", false);
  };
  return (
    <div>
      {/* <?php include('head_meta.php'); ?>
<?php include('header.php'); ?> */}
      <Header>
        <div className="content">
          {/* <!-- ═══════════ PAGE HEADER ═══════════ --> */}
          <div class="ol-header">
            <div class="ol-hd">
              <a
                href="javascript:history.back();"
                class="ol-back"
                title="Go back"
              >
                <i class="bi bi-arrow-left"></i>
              </a>
              <div>
                <div class="ol-title">Developer API</div>
                <div class="ol-sub">
                  <span class="dot"></span> Shipping API{" "}
                  <span class="dot" style={{ background: "var(--t4)" }}></span>{" "}
                  <a href="/channel_list" class="ol-link">
                    Integrations
                  </a>
                </div>
              </div>
            </div>
            <div class="ol-actions">
              <a href="/channel_list" class="ol-btn ghost">
                <i class="bi bi-grid-1x2"></i> Integrations
              </a>
              <a href="#api-keys" class="ol-btn primary">
                <i class="bi bi-key"></i> Get API Key
              </a>
            </div>
          </div>

          {/* <!-- ═══════════ INTRO ═══════════ --> */}
          <div class="ig-hero dapi-hero">
            <span class="ig-eyebrow">
              <i class="bi bi-code-slash"></i> Shipping API
            </span>
            <h1 class="ig-title">Build with the Shipping API</h1>
            <p class="ig-desc">
              Create shipments, track deliveries and fetch rates — everything
              you need to embed shipping into your own product.
            </p>
          </div>

          <div class="dapi-wrap">
            {/* <!-- ═══════════ API KEYS ═══════════ --> */}
            <div class="dapi-section" id="api-keys">
              <div class="dapi-head">
                <div>
                  <h2 class="dapi-title">
                    <i class="bi bi-key"></i> API Keys
                  </h2>
                  <p class="dapi-sub">
                    Keys authenticate every request. Store them somewhere safe
                    and never share them.
                  </p>
                </div>
              </div>

              <div className="card-base ol-co-card">
                <div className="dapi-keys">
                  {/* Customer ID */}
                  <div className="dapi-key-row">
                    <div className="dapi-key-info">
                      <b>Customer ID</b>
                    </div>

                    <code className="dapi-key-code">
                      {state.customer_id || "-"}
                    </code>

                    <span className="dapi-key-acts">
                      <button
                        type="button"
                        className="ol-btn ghost dapi-mini"
                        title="Copy Customer ID"
                        onClick={() => copyText(state.customer_id)}
                      >
                        <i className="bi bi-clipboard"></i>
                      </button>
                    </span>
                  </div>

                  {/* Secret Key */}
                  <div className="dapi-key-row">
                    <div className="dapi-key-info">
                      <b>Secret Key</b>
                    </div>

                    <code className="dapi-key-code">{state.shipment_list}</code>

                    <span className="dapi-key-acts">
                      {/* Copy */}
                      <button
                        type="button"
                        className="ol-btn ghost dapi-mini"
                        title="Copy key"
                        onClick={() => copyText(state.shipment_list)}
                      >
                        <i className="bi bi-clipboard"></i>
                      </button>

                      {/* Show / Hide */}
                      {/* <button
                        type="button"
                        className="ol-btn ghost dapi-mini"
                        title={revealed.secret_key ? "Hide key" : "Show key"}
                        onClick={() => toggleReveal("secret_key")}
                      >
                        <i
                          className={`bi bi-${
                            revealed.secret_key ? "eye-slash" : "eye"
                          }`}
                        ></i>
                      </button> */}

                      {/* Refresh */}
                      {/* <button
                        type="button"
                        className="ol-btn ghost dapi-mini"
                        title="Refresh key"
                        onClick={refreshSecretKey}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button> */}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- ═══════════ POSTMAN ═══════════ --> */}
            <div class="dapi-section" id="api-postman">
              <div class="card-base dapi-postman">
                <span class="dapi-postman-logo">
                  <i class="bi bi-boxes"></i>
                </span>
                <div class="dapi-postman-tx">
                  <h2 class="dapi-title">
                    <i class="bi bi-box-arrow-up-right"></i> Postman Collection
                  </h2>
                  <p class="dapi-sub">
                    Auth, create shipment, tracking and the carrier rate guide —
                    all in one collection. Fork it, add your API key and start
                    shipping in minutes.
                  </p>
                  <div class="dapi-postman-acts">
                    <a
                      href="https://www.postman.com/eagletechnosys/skyship/collection/wrfuhan/skyship-elite"
                      target="_blank"
                      rel="noopener"
                      class="ol-btn primary"
                    >
                      <i class="bi bi-box-arrow-up-right"></i> Open in Postman
                    </a>
                    <a
                      href="https://www.postman.com/downloads"
                      target="_blank"
                      rel="noopener"
                      class="ol-btn ghost"
                    >
                      <i class="bi bi-download"></i> Install Postman
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- ═══════════ CARRIERS & SERVICES ═══════════ --> */}
            <div class="dapi-section" id="api-carriers">
              <div class="dapi-head">
                <div>
                  <h2 class="dapi-title">
                    <i class="bi bi-truck"></i> Carriers &amp; Services
                  </h2>
                  <p class="dapi-sub">
                    Pass the <code class="dapi-inline">service_id</code> of your
                    chosen carrier service in the{" "}
                    <code class="dapi-inline">service</code> field of your
                    create-shipment request.
                  </p>
                </div>
              </div>
              <div class="card-base ol-co-card">
                <div class="dapi-body">
                  <div class="ol-co-table-wrap">
                    <table class="ol-co-table dapi-carrier-tbl">
                      <thead>
                        <tr>
                          <th>Courier Name</th>
                          <th>Product ID</th>
                          <th>Carrier ID</th>
                          <th>Courier ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.length > 0 ? (
                          products.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <b>{item.product_name}</b>
                              </td>
                              <td>{item.product_id}</td>
                              <td>{item.carrier_id}</td>
                              <td>{item.product_type || "N/A"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center text-muted">
                              No courier data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Developer_apis;
